import { render, staticRenderFns } from "./TimelineDecade.vue?vue&type=template&id=bef4260c&scoped=true&"
import script from "./TimelineDecade.vue?vue&type=script&lang=js&"
export * from "./TimelineDecade.vue?vue&type=script&lang=js&"
import style0 from "./TimelineDecade.vue?vue&type=style&index=0&id=bef4260c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bef4260c",
  null
  
)

export default component.exports